import React, { Component } from "react";
import "./styles/Home.css";
import AdListSkeleton from "../components/AdListSkeleton";
import AdList from "../components/AdList";
import AdMenu from "../components/AdMenu";
import { connect } from "react-redux";
import * as actions from "../redux/actions/adListActions";
import SummaryByCountry from "../components/SummaryByCountry";
import Footer from "../components/Footer";
import { Translate } from "react-redux-i18n";
import MiniLoader from "../components/MiniLoader";

class HomeNewAds extends Component {
  componentDidMount() {
    this.fetchAdList();
  }

  onClickLoadingMore = () => {
    this.fetchMoreAdList();
  };

  fetchAdList = async () => {
    try {
      await this.props.LoadAdHome(this.props.user_id, this.props.token);
    } catch (error) {
      console.log(error);
    }
  };

  fetchMoreAdList = async () => {
    try {
      await this.props.LoadMoreAdHome(
        this.props.pageCount,
        this.props.user_id,
        this.props.token
      );
    } catch (error) {
      console.log(error);
    }
  };

  componentWillUnmount() {}

  render() {
    const isLoggedIn = Boolean(this.props.user_id && this.props.token);

    return (
      <React.Fragment>
        <div className="Home-in">
          <div className="col-lg-3 d-none d-lg-block ">
            <div className="Home-left">
              <AdMenu />
              {isLoggedIn && <SummaryByCountry />}
            </div>
          </div>
          <div className="col-lg-9 ">
            {this.props.loading ? (
              <AdListSkeleton count={8} />
            ) : (
              <React.Fragment>
                <AdList adList={this.props.adList} />
                {this.props.page_size >= 10 &&
                  (this.props.loadingMore ? (
                    <div className="text-center">
                      <MiniLoader />
                    </div>
                  ) : (
                    <div
                      className="text-center"
                      onClick={this.onClickLoadingMore}
                    >
                      <button className="btn btn-secondary">
                        <Translate value="load_more" />
                      </button>
                    </div>
                  ))}
              </React.Fragment>
            )}
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

function mapStateToProps(reducer) {
  const pagination = actions.selectCachedAdPagination(
    reducer,
    actions.AD_SOURCES.HOME
  );

  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    adList: actions.selectCachedAdList(reducer, actions.AD_SOURCES.HOME),
    error: reducer.adList.error,
    loading: actions.isAdListLoading(reducer, actions.AD_SOURCES.HOME),
    loadingMore: reducer.adList.loadingMore,
    page_index: pagination.page_index,
    page_size: pagination.page_size,
    pageCount: pagination.page_count,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadAdHome: (user_id, token) =>
    dispatch(actions.loadList({ user_id, token })),
  LoadMoreAdHome: (page_index, user_id, token) =>
    dispatch(actions.loadListScroll({ page_index, user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeNewAds);
